import { render, staticRenderFns } from "./ShipmentDashboard.vue?vue&type=template&id=13d0836e&scoped=true&"
import script from "./ShipmentDashboard.vue?vue&type=script&lang=js&"
export * from "./ShipmentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDashboard.vue?vue&type=style&index=0&id=13d0836e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d0836e",
  null
  
)

export default component.exports